<template>
  <v-snackbar
    v-model="isShow"
    class="notice_box"
    :color="type"
    :timeout="duration"
    multi-line
    top
    :value="isShow"
    @input="handleInput"
  >
    <p>{{ message }}</p>
    <div style="text-align: right">
      <v-btn dark text @click="hide">OK</v-btn>
    </div>
  </v-snackbar>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'info'
    },
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      isShow: false,
      isDestroyed: false
    }
  },
  mounted() {
    // 延迟显示以避免初始化冲突
    this.$nextTick(() => {
      if (!this.isDestroyed) {
        this.show()
      }
    })
  },
  beforeDestroy() {
    this.isDestroyed = true
    this.isShow = false
  },
  destroyed() {
    this.isDestroyed = true
  },
  methods: {
    show() {
      try {
        if (!this.isDestroyed) {
          this.isShow = true
        }
      } catch (error) {
        console.warn('Show notification error:', error)
      }
    },
    hide() {
      try {
        this.isShow = false
        // 延迟销毁组件，让动画完成
        setTimeout(() => {
          if (this.remove && !this.isDestroyed) {
            this.remove()
          }
        }, 300)
      } catch (error) {
        console.warn('Hide notification error:', error)
      }
    },
    handleInput(value) {
      // 处理 v-snackbar 的 input 事件
      if (!value && this.isShow) {
        this.hide()
      }
    }
  }
}
</script>
<style scoped>
.notice_box {
  position: fixed;
  top: 20px;
  z-index: 10000;
}
</style>
